import { BrowserSession } from './browser-session';
import { LocalStorageEventLogStorage } from './event-log-storage';
import { MessagePersistence } from './messages/message-persistence';

export const migrateIdfv = (
  token: string,
  oldIdfv: string,
  newIdfv: string,
  options: { intervalDaysToStorageExpiration: number; cookieDomain: string | undefined }
) => {
  BrowserSession.migrateIdfv(oldIdfv, newIdfv, options);
  MessagePersistence.migrateIdfv(oldIdfv, newIdfv, token);
  LocalStorageEventLogStorage.migrateIdfv(oldIdfv, newIdfv);
};
